import { ThinEvent } from '@/resources/ThinEvent';
import { IThinEvent } from '@/resources/upgrade/ThinEvent';

/**
 * Union type for events that can come from either datx (camelCase) or new API (snake_case)
 */
export type AnyThinEvent = ThinEvent | IThinEvent;

/**
 * Type guard to check if event is the new IThinEvent format (snake_case)
 */
export function isNewEventFormat(event: AnyThinEvent): event is IThinEvent {
  return 'starts_at' in event;
}

export function getEventStartsAt(event: AnyThinEvent): string {
  if (isNewEventFormat(event)) {
    return event.starts_at || '';
  }

  return event.startsAt || '';
}

export function getEventEndsAt(event: AnyThinEvent): string {
  if (isNewEventFormat(event)) {
    return event.ends_at || '';
  }

  return event.endsAt || '';
}

export function getEventDisplayWithTime(event: AnyThinEvent): boolean | undefined {
  if (isNewEventFormat(event)) {
    return event.display_with_time;
  }

  return event.displayWithTime;
}

export function getEventShortDescription(event: AnyThinEvent): string {
  if (isNewEventFormat(event)) {
    return event.short_description || '';
  }

  return event.shortDescription || '';
}

export function getEventSmallLogoUrl(event: AnyThinEvent): string {
  if (isNewEventFormat(event)) {
    return event.small_logo_url || '';
  }

  return event.smallLogoUrl || '';
}

export function getEventMediumHeaderImageUrl(event: AnyThinEvent): string {
  if (isNewEventFormat(event)) {
    return event.medium_header_image_url || '';
  }

  return event.mediumHeaderImageUrl || '';
}

export function getEventLecturesCount(event: AnyThinEvent): number {
  if (isNewEventFormat(event)) {
    return event.lectures_count ?? 0;
  }

  return event.lecturesCount ?? 0;
}

export function getEventSpeakersCount(event: AnyThinEvent): number {
  if (isNewEventFormat(event)) {
    return event.speakers_count ?? 0;
  }

  return event.speakersCount ?? 0;
}

export function getEventConferenceId(event: AnyThinEvent): string {
  if (isNewEventFormat(event)) {
    return event.conference_id || '';
  }

  return event.conferenceId || '';
}

export function getEventTimeZone(event: AnyThinEvent): string | undefined {
  if (isNewEventFormat(event)) {
    return event.time_zone;
  }

  return event.timeZone;
}
